import React from 'react'
import { NavLink } from "react-router-dom";
const Full_height_video = () => {
  return (
    <section className="full-height-video">
    
    <div className="item">
        <span className="offport-down">CX Marries Digital</span>
        <NavLink to={`/cx/cx-marries-digital`} className="btn btn-secondary offport-zoomout">Explore
            Now</NavLink>
    </div>
</section>
  )
}

export default Full_height_video
